export const descriptionAlert = (
  <p>
    Please enter all the details and submit the data. After submission Leave
    request will go to higher officials approval and you can cancel before it
    gets approved by HR Departments.
    <br />
    Each request will be monitored by HR & Payroll Department.
    <br />
    Not all the leaves may be Approved even after submission, so please wait for
    the final Approval from HR & Payroll Department.
  </p>
);
